// src/services/authService.js
import { get, postFormData } from './apiService';

/**
 * Login user with username and password
 * @param {string} username
 * @param {string} password
 * @returns {Promise<string>} Access token
 */
export async function loginUser(username, password) {
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);

  const data = await postFormData('/login', params, { requireAuth: false });
  
  const token = data.access_token;
  localStorage.setItem('accessToken', token);
  await getProfile();
  return token;
}

/**
 * Check if authentication token exists
 * @returns {boolean}
 */
export function isTokenValid() {
  const token = localStorage.getItem('accessToken');
  return !!token;
}

/**
 * Get user data from session storage
 * @returns {object|null}
 */
export function getUserData() {
  const data = sessionStorage.getItem('userData');
  return data ? JSON.parse(data) : null;
}

/**
 * Set authentication token
 * @param {string} token
 */
export async function setUserData(token) {
  localStorage.setItem('accessToken', token);
}

/**
 * Logout user and clear storage
 */
export function logout() {
  localStorage.removeItem('accessToken');
  sessionStorage.removeItem('userData');
}

/**
 * Get current user profile
 * @returns {Promise<object>} User data
 */
export async function getProfile() {
  try {
    const data = await get('/me');
    sessionStorage.setItem('userData', JSON.stringify(data));
    return data;
  } catch (error) {
    if (error.status === 401) {
      window.location.href = '/';
    }
    throw error;
  }
}
